import React from 'react';

// import SearchForm from '../partials/SearchForm';
// import {Provider} from '../context/Context';
import { Link } from 'react-router-dom';
import WithConsumer from '../context/WithConsumer';
// import PostMeta from './PostMeta';
import BackLink from './BackLink';
import menuIcon from '../images/menu.svg';


const Head = ({index,context}) => {

	const bIsHomepage = context.restType === 'home' ? true : false;
    const bIsSitemap = context.slug === 'sitemap' ? true : false;
    // let topIcon = <BackLink/>;

    // if (bIsHomepage) {
    //     topIcon = <Link to="/sitemap/"><img src={menuIcon} alt="Menu"/></Link>;
    // }

    return (<div className="header">
    			{/* {( bIsSitemap !== true ) && (
                    <Link to="/sitemap/"><img src={menuIcon} alt="Menu"/></Link>
                    )} */}
                {(bIsHomepage !== true && bIsSitemap !== true) && (
                    <div>
                    <BackLink/>
                    <Link to="/sitemap/"><img src={menuIcon} alt="Menu"/></Link>
                    </div>
                )}
                {/* { topIcon } */}
            </div>)
};
export default WithConsumer(Head);